export class AgeGenderDistributionData
{
    value:number;
    ageGenderColId:number;
    ageGenderRowId:number;
    ageGenderGroupName:string;
}